import { isSSR } from '@front10/utils';

export function notifyFullMode() {
  const event = document.createEvent('Event');
  event.initEvent('container-enter-full-screen', true, true);
  window.dispatchEvent(event);
}

export function notifyExitFullMode() {
  const event = document.createEvent('Event');
  event.initEvent('container-exit-full-screen', true, true);
  window.dispatchEvent(event);
}
const stopScroll = () => {
  window.scrollTo(0, 0);
};

/**
 * Use to view container in full mode
 */
export const enterFullMode = (ref) => {
  const container = ref.current;
  if (container && !isSSR()) {
    if (!window.FR) {
      window.FR = {};
    }
    window.FR.scroll = { top: window.scrollY };
    window.addEventListener('scroll', stopScroll);
    const {
      style: { minHeight }
    } = container;
    document.body.style.overflow = 'hidden';
    container.style.position = 'fixed';
    container.style.padding = '0';
    container.style.top = '0';
    container.style.left = '0';
    container.style.width = '100%';
    container.style.height = '100%';
    container.style.backgroundColor = 'white';
    container.style.zIndex = '10000';
    container.style.minHeight = null;
    container.style.overflowY = 'auto';
    container.setAttribute('data-min-height', minHeight);
  }
};

export const exitFullMode = (ref) => {
  const container = ref.current;
  if (container && !isSSR()) {
    if (!window.FR) {
      window.FR = {};
    }
    if (!window.FR.scroll) {
      window.FR.scroll = { top: 0 };
    }
    window.removeEventListener('scroll', stopScroll);
    window.scrollTo(0, window.FR.scroll.top);
    const minHeight = ref.current.getAttribute('data-min-height');
    document.body.style.overflow = null;
    document.body.style.overflowY = null;
    container.style.overflow = null;
    container.style.position = null;
    container.style.top = null;
    container.style.left = null;
    container.style.width = null;
    container.style.height = null;
    container.style.backgroundColor = null;
    container.style.zIndex = null;
    container.style.padding = null;
    container.style.minHeight = minHeight;
  }
};
